import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const DonationSuccessPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-6">
      <motion.div 
        className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex justify-center mb-6">
          <CheckCircle size={64} className="text-green-500" />
        </div>
        
        <h1 className="font-display text-h2 text-secondary mb-4">Thank You!</h1>
        
        <p className="text-textPrimary mb-6">
          Your donation has been successfully processed. Your generosity will make a real difference 
          in the lives of refugee students worldwide.
        </p>
        
        <div className="bg-lightTeal rounded-lg p-4 mb-6 text-left">
          <p className="text-secondary font-body">
            <span className="font-bold">What happens next?</span>
            <br />
            You'll receive a confirmation email with the details of your donation for your records.
            If you've set up a monthly donation, you'll be charged automatically each month.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <motion.button 
              className="flex items-center justify-center w-full sm:w-auto px-6 py-3 bg-white border-2 border-primary text-primary rounded-xl font-bold transition-all"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Home size={18} className="mr-2" />
              Return Home
            </motion.button>
          </Link>
          
          <Link to="/impact">
            <motion.button 
              className="flex items-center justify-center w-full sm:w-auto px-6 py-3 bg-cta text-white rounded-xl font-bold shadow-md transition-all"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              See Your Impact
              <ArrowRight size={18} className="ml-2" />
            </motion.button>
          </Link>
        </div>
      </motion.div>
      
      <p className="mt-8 text-gray-500 text-sm">
        Tax receipts will be issued for donations over $25
      </p>
    </div>
  );
};

export default DonationSuccessPage;